
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/innovate",
      function () {
        return require("private-next-pages/event/innovate/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/innovate"])
      });
    }
  